<template>
  <div class="overflow-y-scroll h-96">
    <div
      v-for="(activity, index) in activities"
      :key="index"
      class="flex gap-x-4 items-center py-3 md:py-5 w-full"
    >
      <div class="font-normal text-sm text-fg-subtle w-28">
        {{ parseRelativeTime(activity.createdAt) }}
      </div>
      <div class="relative">
        <div class="rounded-full bg-info-subtle p-3">
          <activities-icon size="h-5 w-5" />
        </div>
        <div
          :class="
            index === activities.length - 1
              ? ''
              : 'border-l-2 h-20 absolute left-5'
          "
        ></div>
      </div>
      <div class="w-full">
        <p class="capitalize pb-1.5">
          {{ activity.action }}
        </p>
        <p class="font-normal text-fg-muted text-sm">
          {{ activity.details }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { ParseRelativeTime } from '@/utils/helpers.js'
export default {
  props: {
    activities: {
      type: Array,
      default: () => []
    }
  },
  components: {
    ActivitiesIcon: () => import('@/assets/v2/icons/ActivitiesIcon.vue')
  },
  methods: {
    parseRelativeTime (timeToPick) {
      return ParseRelativeTime(timeToPick)
    }
  }
}
</script>
